"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @Desc
 * @Author leon <leondwong@gmail.com>
 * @Date 6/12/18
 */
__export(require("./sso_web"));
var config_client_1 = require("./config_client");
exports.setPkgVersion = config_client_1.setPkgVersion;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/index.js